// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kU32j","content":"styles_content__1f7J5"};